import API from 'services/api';

export const deleteUser = ({
  userId,
  customerId,
}: {
  userId: number | string | null;
  customerId: number | undefined;
}) => {
  return API.delete(`/api/users/${userId}/softDelete`, { data: { customerId } });
};
